// src/utils/analyticsSetup.ts

// GA4 is NOT loaded here, and no longer in index.html either. Loading it is
// src/utils/consent.ts's job, and only happens after an explicit accept - see
// the comment in index.html for why.
//
// This file only ensures `gtag` is callable, so in-app event tracking does not
// throw when analytics has NOT been loaded. Those calls then queue into
// dataLayer and go nowhere, which is the correct behaviour for a visitor who
// declined: the app carries on working and nothing is transmitted.

export const setupGoogleAnalytics = () => {
  const analyticsId = import.meta.env.VITE_GOOGLE_ANALYTICS_ID;
  if (!analyticsId) return;

  // The <script> tag is already in index.html — just ensure gtag is callable
  (window as any).dataLayer = (window as any).dataLayer || [];
  if (!(window as any).gtag) {
    (window as any).gtag = function gtag(...args: unknown[]) {
      (window as any).dataLayer.push(args);
    };
  }
};

export const setupGoogleServices = () => {
  // Previously also gated on VITE_ADS_ENABLED. Google advertising has been removed
  // entirely, so analytics is the only Google service left - and whether it LOADS is
  // decided by consent, not by this. All this does is make `gtag` callable so in-app
  // event tracking does not throw when it has not been loaded.
  setupGoogleAnalytics();
};
